var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"height":"100%","width":"100%","border":"none"},attrs:{"src":"http://wicrecloud.cn/help/projchangshou/help.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }